type ConditionalWrapperProps = {
  wrap: boolean;
  renderWrapper: (children: React.ReactElement) => React.ReactElement;
  children: React.ReactElement;
};

/**
 *
 * Renders children with wrapper or without based on the value of wrap prop
 */
export const ConditionalWrapper = ({
  wrap,
  renderWrapper,
  children
}: ConditionalWrapperProps) => {
  return wrap ? renderWrapper(children) : children;
};
